import { provideCalAngular } from '@cvx/cal-angular';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { LoadingInterceptor } from './interceptors/loading.interceptor';
import { AuthInterceptor } from './interceptors/auth.interceptor';
import { environment } from '@env/environment';

export const CAL_PROVIDERS = environment.calConfig 
  ? [provideCalAngular(environment.calConfig)]
  : [];

export const CORE_INTERCEPTORS_PROVIDERS = [
  {
    provide: HTTP_INTERCEPTORS,
    useClass: AuthInterceptor,
    multi: true
  },
  {
    provide: HTTP_INTERCEPTORS,
    useClass: LoadingInterceptor,
    multi: true
  }
];

export const coreConfig = {
  providers: [
    ...CAL_PROVIDERS,
    ...CORE_INTERCEPTORS_PROVIDERS
  ]
};
